import types from './action-types';

const initialState = {
    profiles: [],
    file: {},
    searchedProfiles: []
};

export default (state = initialState, action) => {
    let newState = state;

    switch (action.type) {
        case types.PROFILES_LOADED:
            newState = profilesLoaded(action, state);
            break;
        case types.SELECTED_PROFILE:
            newState = profileSelected(action, state);
            break;
    }

    return newState;
};

const profilesLoaded = (action, state) => {
    return {
        ...state,
        profiles: action.profiles,
        file: { fileGuid: action.fileGuid, fileName: action.fileName }
    }
};

const profileSelected = (action, state) => {
    const { profileId, checked } = action;
    const profiles = state.profiles.map(p => {
        if (p.profileId === profileId) {
            return { ...p, shouldImport: checked }
        }
        return p;
    });

    return { ...state, profiles: profiles };
}



// WEBPACK FOOTER //
// ./App/components/modules/measurement-validator/store/reducer.js